import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["config"]

  toggle(event) {
    const show = event.target.checked
    this.configTarget.style.display = show ? "block" : "none"
  }
}
